import { useParams } from "react-router";

import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellLink from "ds/components/Table/Row/CellLink";
import Box from "ds/components/Box";
import Icon from "ds/components/Icon";
import { File } from "components/icons/generated";
import { RepoFile } from "types/generated";

import { getFileEditUrl, parseFilePath } from "../../../helpers";

const FileNameCell = ({ item, ...cellProps }: TableSimpleCellProps<RepoFile>) => {
  const { repoId } = useParams<{ repoId: string }>();
  const { name } = parseFilePath(item.filePath);

  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <Box direction="row" align="center" gap="medium">
        <Icon src={File} noShrink />
        <TableCellLink href={getFileEditUrl(repoId!, item.filePath)}>{name}</TableCellLink>
      </Box>
    </TableSimpleCell>
  );
};

export default FileNameCell;
